import { Component, ojs, app } from "modular-openscriptjs";
import { _UNIQUE_ID_ } from "../../declarations";
import { disposeBootstrapTree, isMobile, wasClicked } from "../../helpers";
import { dom } from "../../fotastart";

const h = app("h");

export default class MoreOptions extends Component {
	render(array, ...args) {
		let id = `${_UNIQUE_ID_}`;

		let hook =
			array[0] ??
			h.button(
				{
					class: "text-secondary text-end btn btn-outline-dark border-0 dropdown-toggle d-after-none",
					title: "More options",
				},
				h.i({
					class: "fas fa-ellipsis-vertical",
				}),
			);

		let children = array[1] ?? h.div();

		if (Array.isArray(children)) {
			children = h.wrapper(children);
		}

		let db = h.div(
			{
				class: "d-none position-absolute shadow border-0 rounded bg-white p-3",
				style: `max-width: fit-content; z-index: 1000`,
				mo_dropdown_body: `mo-db-${id}`,
			},
			children,
		);

		hook.addListener("click", () => {
			if (isMobile()) {
				dom.get(`[mo-canvas-hook='mo-canvas-hook-${id}']`)?.click();
			} else {
				this.toggleDropdown(
					dom.get(`[mo-id='mo-hk-${id}-c']`),
					dom.get(`[mo-dropdown-body='mo-db-${id}']`),
				);
			}
		});

		let oh = h.button({
			class: "d-none",
			data_bs_target: `[mo-canvas-body='mo-canvas-${id}']`,
			data_bs_toggle: "offcanvas",
			mo_canvas_hook: `mo-canvas-hook-${id}`,
		});

		/**
		 * @type {HTMLElement}
		 */
		let obChild = children.cloneNode(true);

		h.modify(obChild);

		obChild.addListener("click", function (e) {
			if (this.contains(e.target)) {
				dom.get(`[mo-canvas-dismiss-btn='mo-canvas-${id}']`)?.click();
			}
		});

		children.setAttribute("mo-id", `mo-db-${id}-c`);
		obChild.setAttribute("mo-id", `mo-ob-${id}-c`);
		hook.setAttribute("mo-id", `mo-hk-${id}-c`);

		children.addListener("click", function (e) {
			let db = dom.get(`[mo-dropdown-body='mo-db-${id}']`);

			if (this.contains(e.target) && !db?.classList.contains("d-none")) {
				db.classList.add("d-none");
			}
		});

		window.addEventListener("click", (e) => {
			let db = dom.get(`[mo-dropdown-body='mo-db-${id}']`);
			let hook = dom.get(`[mo-id='mo-hk-${id}-c']`);

			if (wasClicked(hook, e)) return;

			if (!wasClicked(db, e) && !db?.classList.contains("d-none")) {
				db?.classList.add("d-none");
			}
		});

		let ob = h.div(
			{
				class: "border-0 offcanvas offcanvas-bottom rounded-top-5",
				tabindex: "-1",
				mo_canvas_body: `mo-canvas-${id}`,
				style: `min-height: fit-content;`,
				data_bs_scroll: "true",
			},
			h.button({
				class: "d-none",
				mo_canvas_dismiss_btn: `mo-canvas-${id}`,
				data_bs_dismiss: "offcanvas",
			}),

			h.div({ class: "offcanvas-body fs-5" }, obChild),
		);

		return h.div(
			{ class: "position-relative" },
			[hook, oh, ob, db],
			...args,
		);
	}

	/**
	 *
	 * @param {HTMLElement} dropdown
	 * @param {HTMLElement} button
	 */
	positionDropdown(dropdown, button) {
		let buttonRect = button.getBoundingClientRect();
		let dropdownRect = dropdown.getBoundingClientRect();

		let viewportHeight = window.screen.availHeight;
		let viewportWidth = window.screen.availWidth;

		let spaces = {
			top: buttonRect.y,
			bottom: viewportHeight - (buttonRect.y + buttonRect.height),
			left: buttonRect.x,
			right: viewportWidth - (buttonRect.x + buttonRect.width),
		};

		const [dw, dh, x, y] = [
			dropdownRect.width,
			dropdownRect.height,
			dropdownRect.x,
			dropdownRect.y,
		];

		if (x + dw <= viewportWidth) return;

		if (dw > spaces.left && dw > spaces.right) {
			dropdown.style.right = `${viewportWidth - (x + dw)}px`;
		} else if (dw > spaces.right) {
			dropdown.style.left = `${viewportWidth - x - dw - 10}px`;
		}

		if (dh > spaces.top && dh > spaces.bottom) {
			dropdown.style.top = `${viewportWidth - (x + dh)}px`;
		} else if (dh > spaces.bottom) {
			dropdown.style.bottom = `${viewportHeight - x - dh - 10}px`;
		}
	}

	toggleDropdown(hook, dropdown) {
		dropdown.classList.toggle("d-none");
		this.positionDropdown(dropdown, hook);
	}

	cleanUp() {
		super.cleanUp();
		let markup = this.markup();

		for (let elem of markup) {
			disposeBootstrapTree(elem);
		}
	}
}

ojs(MoreOptions);
